import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const StockCountService = {
  getAllCnt: async () => {
    try {
      const response = await axios.get(ENDPOINT.StockCount);
      return response.data;
    } catch (error) {
      console.error("Error fetching Stock Counts:", error.message);
      throw error;
    }
  },

  getCntStats: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.StockCount}/stats`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Stock Count stats:", error.message);
      throw error;
    }
  },

  getLastCnt: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.StockCount}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching last Stock Count:", error.message);
      throw error;
    }
  },

  getDistinctValues: async (field) => {
    try {
      const response = await axios.get(`${ENDPOINT.StockCount}/distinct/${field}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching distinct values:", error.message);
      throw error;
    }
  },

  getCntById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.StockCount}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Stock Count:", error.message);
      throw error;
    }
  },

  createCnt: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.StockCount, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating Stock Count:", error.message);
      throw error;
    }
  },

  updateCnt: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.StockCount}/${id}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating Stock Count:", error.message);
      throw error;
    }
  },

  updateStatus: async (id, status) => {
    try {
      const response = await axios.put(`${ENDPOINT.StockCount}/${id}/status`, { status });
      return response.data;
    } catch (error) {
      console.error("Error updating Stock Count status:", error.message);
      throw error;
    }
  },

  deleteCnt: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.StockCount}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting Stock Count:", error.message);
      throw error;
    }
  },
};